import ImgIcon, { ImgIconProps } from '../ImgIcon/ImgIcon';

export interface DbtIconProps extends Omit<ImgIconProps, 'src' | 'alt'> {}

export default function DbtIcon(props: DbtIconProps) {
  return <ImgIcon src="/images/bi_icons/dbt.svg" alt="dbt icon" size={props.size} />;
}
